'use strict';

const AUTH_FIREBASE = '@@auth/AUTH_FIREBASE';
const AUTH_FIREBASE_SUCCESS = '@@auth/AUTH_FIREBASE_SUCCESS';
const AUTH_FIREBASE_ERROR = '@@auth/AUTH_FIREBASE_ERROR';

/**
 *
 * @param {string} firebaseToken
 * @return {ReduxAction}
 */
export function authFirebase(firebaseToken) {
  return {
    type: AUTH_FIREBASE,
    payload: {
      token: firebaseToken,
    },
  };
}
authFirebase.TYPE = AUTH_FIREBASE;

/**
 *
 * @param {?string} userId
 * @return {ReduxAction}
 */
export function firebaseAuthSuccess(userId) {
  return {
    type: AUTH_FIREBASE_SUCCESS,
    payload: {
      userId,
    },
  };
}
firebaseAuthSuccess.TYPE = AUTH_FIREBASE_SUCCESS;

/**
 *
 * @param {Error} err
 * @return {ReduxAction}
 */
export function firebaseAuthError(err) {
  return {
    type: AUTH_FIREBASE_ERROR,
    payload: {
      err,
    },
  };
}
firebaseAuthError.TYPE = AUTH_FIREBASE_ERROR;



// WEBPACK FOOTER //
// ./src/js/auth/actions/firebase.js